import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService:AuthService, private router:Router) { }

  canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean {
    if(!this.authService.isAuthenticated()){
        this.router.navigate(['login']);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/guard/auth.guard.ts